export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pQ05TLVVURjgtSEIG4oCTeAACEBu08WmB1QaIC4HUVwEAYgfjgIgBgRYAAYESAAGBGgABgR4AAYEOAgGBCrD3cgGBAg==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniCNS-UTF8-V.bcmap
// module id = 693
// module chunks = 502